import { StringKey } from '../../../../lang/index';

export enum TemplateFilter {
  ALL = 'all',
  NOT_USED = 'not-used',
  USED = 'used',
}

export const statusFilterMap: TemplateFilter[] = [
  TemplateFilter.ALL,
  TemplateFilter.NOT_USED,
  TemplateFilter.USED,
];

export const statusFilterTranslationKey: Record<TemplateFilter, StringKey> = {
  [TemplateFilter.ALL]: 'FILTER_ALL',
  [TemplateFilter.NOT_USED]: 'FILTER_NOT_USED',
  [TemplateFilter.USED]: 'FILTER_IN_USE',
};
